import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";
import { useCart } from "../contexts/CartContext";
import { ArrowLeft, Calendar, MapPin, Users } from "lucide-react";
import { toast } from "sonner";

export default function EventDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [e, setE] = useState(null);
  useEffect(() => {
    api.get(`/events/${slug}`).then(r => setE(r.data)).catch(() => navigate("/events"));
  }, [slug, navigate]);
  if (!e) return <div className="lumina-container py-20 text-center text-[#5C5870]">Memuat…</div>;
  const join = () => {
    addItem({ item_type: "event", item_id: e.id, title: e.title, price: e.price, image: e.image, schedule: e.date });
    toast.success("Tiket ditambahkan ke keranjang");
    navigate("/checkout");
  };
  return (
    <div className="lumina-container py-12" data-testid="event-detail-page">
      <Link to="/events" className="inline-flex items-center gap-2 text-[#5C5870] hover:text-[#6B4BA3] mb-8 text-sm"><ArrowLeft className="w-4 h-4" /> Kembali</Link>
      <div className="grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-3">
          <div className="lumina-card overflow-hidden mb-8">
            <img src={e.image} alt={e.title} className="w-full aspect-[16/10] object-cover" />
          </div>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-[#1A1728] mb-6 leading-tight">{e.title}</h1>
          <p className="text-[#5C5870] leading-relaxed text-lg">{e.long_description || e.description}</p>
        </div>
        <div className="lg:col-span-2">
          <div className="lumina-card p-7 sticky top-28">
            <div className="text-[#6B4BA3] font-semibold text-3xl mb-6">{e.price === 0 ? "GRATIS" : formatRupiah(e.price)}</div>
            <div className="space-y-4 text-sm text-[#1A1728] mb-6">
              <div className="flex items-start gap-3"><Calendar className="w-4 h-4 text-[#6B4BA3] mt-0.5" /> <div><div className="font-medium">Tanggal</div><div className="text-[#5C5870]">{new Date(e.date).toLocaleString("id-ID", { dateStyle: "long", timeStyle: "short" })}</div></div></div>
              <div className="flex items-start gap-3"><MapPin className="w-4 h-4 text-[#6B4BA3] mt-0.5" /> <div><div className="font-medium">Lokasi</div><div className="text-[#5C5870]">{e.location}</div></div></div>
              <div className="flex items-start gap-3"><Users className="w-4 h-4 text-[#6B4BA3] mt-0.5" /> <div><div className="font-medium">Kapasitas</div><div className="text-[#5C5870]">{e.capacity} peserta</div></div></div>
            </div>
            <button onClick={join} className="lumina-btn-primary w-full" data-testid="event-join-button">{e.price === 0 ? "Daftar Gratis" : "Daftar Sekarang"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
